import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input, OnChanges, OnInit, Output, SimpleChanges
} from "@angular/core";

@Component({
  selector: "n-option",
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NOptionComponent implements OnInit, OnChanges {
  // inject services here
  @Input() value: any;
  @Input() heading: string;
  @Input() description: string;
  @Input() iconId: string;
  @Input() iconColor: string;
  @Input() divider: string | boolean;
  @Input() tid: string;

  @Output() change = new EventEmitter<SimpleChanges>();

  get isDivider(): boolean {
    return !!this.divider || this.divider === "";
  }

  ngOnInit() {
    if (this.value === undefined) {
      this.value = this;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.change.emit(changes);
  }
}
